import React from 'react'

import { Menu, Footer } from '@niimko/drupal_menu'

import { HeaderComponent } from '@/components/Header';
import { BodyComponent } from './Body';
import ThemeContext, { themes } from '@/theme/context'
import { Calltoaction } from '@/components/Calltoaction';
import { NewsComponent } from '@/components/News';
import { Slider } from '@/components/Slider';

export const Fieb = (props) => {
    return (
        <ThemeContext.Provider value={themes.fieb}>
            <HeaderComponent {...props} currentAct="fieb"/>
            <Menu {...props}/>
            <Slider
                background='/themes/bakalavr/images/slider.svg'
                header='Независимая оценка качества образования выпускников в&nbsp;соответствии c&nbsp;требованиями ФГОС ВО'
                currentAct={props.currentAct}
            />
            <NewsComponent {...props} />
            <BodyComponent {...props}/>
            <Calltoaction {...props} />
            <Footer {...props}/>
        </ThemeContext.Provider>
    )
}